import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_EA_CASE_DETAIL_LIST = "GET_EA_CASE_DETAIL_LIST";

export const service = async (auditId) => {
  const options: object = {
    url: "/Api/ExternalAudit/GetEaCaseDetailList/" + auditId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EA_CASE_DETAIL_LIST, service, mock);
